import { Instance, types } from 'mobx-state-tree';

import { ECommerceAnalyticsEventPartial } from '../../../infrastructure/analytics/gtm-support';
import { getRootStore } from '../../root/RootStoreUtils';

export const OrderTotalReviewStore = types
  .model('OrderTotalReviewStore', {
    subtotal: types.number,
    shipping: types.number,
    taxTotal: types.number,
    total: types.number,
    pvTotal: types.number,
    taxableAmount: types.number,
    salesTax: types.number,
    shippingTax: types.number,
    activeTaxTab: types.maybe(types.boolean)
  })
  .views(self => ({
    get eCommerceData(): ECommerceAnalyticsEventPartial {
      const { currency } = getRootStore(self).reference;
      return {
        purchase: {
          actionField: {
            revenue: currency.toDecimalAmount(self.total),
            tax: currency.toDecimalAmount(self.taxTotal),
            shipping: currency.toDecimalAmount(self.shipping)
          }
        }
      };
    }
  }))
  .actions(self => ({
    switchTabTaxDefinition(value: boolean) {
      self.activeTaxTab = value;
    }
  }));

export type OrderTotalReviewStore = Instance<typeof OrderTotalReviewStore>;
